import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { CertRequirementCatalogDetail } from '@ats/api/cm';
import { Apollo, gql } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CrcatGuardData } from '../models';
import { CmSettingsService } from '../services';

const CRCAT_QUERY = gql`
	query certRequirementCatalogDetail($request: RequestByIdOrExternalId!) {
		certRequirementCatalogDetail(request: $request) {
			id
			type
		}
	}
`;

@Injectable()
export class CmCrcatTypeGuard implements CanActivate {
	constructor(
		private readonly apollo: Apollo,
		private readonly router: Router,
		private readonly settings: CmSettingsService
	) {}

	canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
		return this.checkCrcatType$(route);
	}

	private checkCrcatType$(route: ActivatedRouteSnapshot): Observable<UrlTree | boolean> {
		const crcatGuardData: CrcatGuardData = (route.data || {}).crcatGuard || null;

		if (
			!crcatGuardData ||
			!crcatGuardData.allowedTypes ||
			!crcatGuardData.idParam ||
			!route.paramMap.has(crcatGuardData.idParam)
		) {
			throw new Error('CmCrcatTypeGuard missing critical data on route');
		}

		return this.apollo
			.query<{ certRequirementCatalogDetail: Pick<CertRequirementCatalogDetail, 'id' | 'type'> }>({
				query: CRCAT_QUERY,
				variables: {
					request: {
						id: +route.paramMap.get(crcatGuardData.idParam),
					},
				},
			})
			.pipe(
				map(({ data }) => (data.certRequirementCatalogDetail || {}).type),
				map(
					type =>
						crcatGuardData.allowedTypes.includes(type) ||
						this.router.createUrlTree(this.settings.route(['not-found']))
				)
			);
	}
}
